import { Link } from "react-router-dom";

export const SiteFooter = () => (
  <footer className="site-footer" data-testid="site-footer">
    <nav className="footer-links" aria-label="Legal and support" data-testid="footer-navigation">
      <Link to="/privacy" data-testid="footer-privacy-link">Privacy</Link>
      <Link to="/terms" data-testid="footer-terms-link">Terms</Link>
      <Link to="/contact" data-testid="footer-contact-link">Contact</Link>
    </nav>
    <p className="language-note" data-testid="language-availability-note">Available in 14 languages</p>
    <p className="footer-copyright" data-testid="footer-copyright">© 2026 Val Bressi Studios</p>
  </footer>
);